import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function emailValidator(pattern: RegExp): ValidatorFn {
  return (control: AbstractControl): ValidationErrors =>
    !control.value || pattern.test(control.value) ? null : { email: true };
}
